import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { BehaviorSubject } from "rxjs";
import { EncriptionService } from "src/app/features/shared/services/Encription.service";
import { LocalStorageService } from "src/app/features/shared/services/LocalStorage.service";
import { SessionService } from "src/app/features/shared/services/Session.service";
import { FrecuencyZonesLayerControlService } from "./frecuencyZonesLayerControl.service";


@Injectable({
  providedIn: "root",
})
export class FrecuencyZonesMapSectionService {

    isVisible: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    constructor(private sessionService:  SessionService, 
            private localStorageService:  LocalStorageService, 
            private encriptionService:  EncriptionService,
            private frecuencyZonesLayerControlService: FrecuencyZonesLayerControlService,
            private dialog: MatDialog) {

    }

    setIsFrecuencyZonesVisible(resp: boolean) {
        this.isVisible.next(resp);
    }

    getIsFrecuencyZonesVisible() {
        return this.isVisible.asObservable();
    }

    async loadLayers(): Promise<void> {
        try {
            // this.frecuencyZonesLayerControlService.configure(this.selectorWithLevelsPrefixAdd);

            await this.frecuencyZonesLayerControlService.createAllSourcesAndLayer();
            return Promise.resolve();
        } catch (error) {
          return Promise.reject(error);
        }
    }

    loadGeoJson(geoJson: any): void {
        this.frecuencyZonesLayerControlService.loadGeoJson(geoJson);
    }

    destroyLayers(): void {
        this.frecuencyZonesLayerControlService.destroy();
    }

    openPopUp(identifier: string, coords: number[]){
        this.frecuencyZonesLayerControlService.openPopUp(identifier, coords);
    }

    closePanel(){
        this.setIsFrecuencyZonesVisible(false);
    }

    initializeFrecuencyZonesMapSection() {
        // this.addViewAsLoadedToStorage();
    }

    // addViewAsLoadedToStorage(){
    //     const mapLoadedViewsEnc = this.localStorageService.getMapLoadedViews();
    //     if (mapLoadedViewsEnc == null) {
    //         return;
    //     }
    
    //     const decrypted = this.encriptionService.DecryptData(mapLoadedViewsEnc);
    //     if (decrypted == null) {
    //         this.localStorageService.setMapLoadedViews(this.encriptionService.EncryptData(JSON.stringify([MAP_MODULE_NAMES.Frequency_Zones])) );
    //         this.sessionService.loadedMapComponents.next([MAP_MODULE_NAMES.Frequency_Zones]);
    //         return;
    //     }
    
    //     var arr: any[] = [];
    //     try {
    //         const parsed = JSON.parse(decrypted);
    //         arr = parsed;
    //     } catch (e) {
    //         arr = [];
    //     }
    
    //     const key = MAP_MODULE_NAMES.Frequency_Zones;
    //     if (!arr.includes(key)) {
    //         arr.push(key);
    //         this.localStorageService.setMapLoadedViews(this.encriptionService.EncryptData(JSON.stringify(arr)) );
    //         this.sessionService.loadedMapComponents.next(arr);
    //     }
    // }
}